import script from "./AllContentPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AllContentPage.vue?vue&type=script&setup=true&lang=js"

import "./AllContentPage.vue?vue&type=style&index=0&id=343d78fd&lang=css"

const __exports__ = script;

export default __exports__